/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {PersonalizedAdsOptOutRequest} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'
import {PersonalizedAdsOptOutResponse} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'


export const personalizedAdsOptOut = (request:PersonalizedAdsOptOutRequest, options?: CashRequestOptions) => post<PersonalizedAdsOptOutRequest, PersonalizedAdsOptOutResponse>("/2.0/cash/personalized-ads-opt-out", request, {...options, rejectOnError: true })